import type { AnyAction, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { ConnectError } from '@bufbuild/connect';

import { authModel } from '@/entities/auth';

export const errorMiddleware: Middleware =
  ({ dispatch }: MiddlewareAPI) =>
  (next) =>
  (action: AnyAction) => {
    if (isRejectedWithValue(action)) {
      const errorMessage = (action.payload as any).message;

      const errorType = (action.payload as any).type;
      // eslint-disable-next-line no-console
      console.warn(
        `Receive api error: ${errorMessage}, error type: ${errorType}`,
      );
      if (errorType === 'UnauthenticatedError') {
        localStorage.removeItem('accessToken');

        dispatch(authModel.actions.setIsAuthenticated(false));
      }
    }

    return next(action);
  };
